import { apiClient, ApiResponse } from './client'
import type { DeviceContext } from './auth'

export type AttendanceStatus = 'IN' | 'OUT' | 'ABSENT' | 'LEAVE'

/** 파생 원생상태 wire 코드 (대기/재원/휴원/퇴원 — 표시는 i18n 매핑) */
export type EnrollmentStatusCode = 'WAITING' | 'ENROLLED' | 'ON_LEAVE' | 'WITHDRAWN'

export interface TodayAttendance {
  attendanceStatus: AttendanceStatus | null
  enrollmentStatus: EnrollmentStatusCode
  /** ON_LEAVE일 때 휴원 기간(안내 배너용, ISO date) */
  leaveStart?: string | null
  leaveEnd?: string | null
  /**
   * 콘텐츠 사용료 게이트 상태 (ContentFeeGate.evaluate 결과).
   * null = 통과, "NONE" | "NOT_STARTED" | "EXHAUSTED" | "EXPIRED" = 차단.
   */
  contentFeeGate?: string | null
  trialStatus?: 'PENDING' | 'ACTIVE' | null
  trialSetCode?: 'A' | 'B' | 'C' | 'D' | 'E' | null
  trialPeriodEnd?: string | null
  trialRemainingDays?: number | null
  /** Most recent PRESENT session, including a prior-day session closed after midnight. */
  latestSession?: {
    attendanceId: number
    attendanceDate: string
    checkOutAt: string | null
    source: 'DEVICE_LOGIN' | 'DEVICE_LOGOUT' | 'TEACHER' | 'AUTO_CLOSE'
  } | null
}

export const attendanceApi = {
  checkInRegisteredDevice: () =>
    apiClient.post<ApiResponse<DeviceContext>>('/lc/my/attendance/check-in'),

  getToday: () =>
    apiClient.get<ApiResponse<TodayAttendance>>('/lc/my/attendance/today'),
}
